import React from 'react'
import { AppBar, Toolbar, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { User } from '@aag-translations/common/lib'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    display: 'flex',
    flex: '0 0 auto',
    backgroundColor: '#00B482', // BBraun Grün
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1300, // Höher als Drawer (1200)
}))

const StyledToolbar = styled(Toolbar)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: '64px',
    paddingLeft: '24px',
    paddingRight: '24px',
})

export default (props: { user: User }) => {
    const { user } = props
    return (
        <StyledAppBar>
            <StyledToolbar>
                <Typography variant="h6" sx={{ color: 'white' }}>Aesculap Translations</Typography>
                <Typography variant="body2" sx={{ color: 'white' }}>{user.firstName} {user.lastName}</Typography>
            </StyledToolbar>
        </StyledAppBar>
    )
}
